angular.module('leanlaw').controller('InvoiceEditorCtrl', ['$scope', 'onboardService', '$q', '$stateParams', '$state', '$filter', 'userService', 'leanLawApi', 'invoiceFilterService', 'invoiceEditorService', 'alerts', 'matterManager', 'clientManager', 'accountingService', 'tracking', function ($scope, onboardService, $q, $stateParams, $state, $filter, userService, leanLawApi, invoiceFilterService, invoiceEditorService, alerts, matterManager, clientManager, accountingService, tracking) {
  alerts.dismiss();
  let _loadedState;
  $scope.print = print;
  $scope.loading = true;
  $scope.invoice = invoiceEditorService.init();
  $scope.format = invoiceEditorService.state.format;
  $scope.state = invoiceEditorService.state;
  $scope.filter = invoiceFilterService.state;
  $scope.preventSubmit;
  $scope.quickbooks = false;
  if (!$stateParams.items) {
    return $state.go('^');
  }
  $scope.colspan = function () {
    return 4 + ($scope.invoice.ledes && !$scope.format.includeCodes ? 1 : 0) + ($scope.customFlagLabel ? 1 : 0);
  };
  $scope.hold = function (entry) {
    invoiceEditorService.hold(entry);
  };
  $scope.delete = function (entry) {
    bootbox.confirm("Are you sure you want to delete this time entry? It will be removed from the system.", result => {
      if (result) {
        leanLawApi.deleteEntry({
          id: entry.id
        }).then(() => {
          $state.go('.', {}, {
            reload: true
          });
        }).catch(err => {
          alerts.error(err);
        });
      }
    });
  };
  $scope.clear = function () {
    invoiceEditorService.clear();
  };
  $scope.save = function (submit) {
    const invoiceName = $scope.invoice.name();
    const filter = invoiceFilterService.filterQuery();
    const checkboxesChecked = $stateParams.items.checkboxesChecked || '';
    bootbox.confirm(submit ? "<h5>Submit invoice to QuickBooks?</h5><p>This will lock the time entries. You can undo this if you made a mistake.</p>" : "<h5>Save Draft invoice?</h5><p>This will lock the time entries. You can undo this if you made a mistake.</p>", result => {
      if (result) {
        $scope.sending = submit;
        $scope.saving = !submit;
        invoiceEditorService.save(invoiceName, submit, filter, checkboxesChecked).then(msg => {
          alerts.success(msg);
          onboardService.reload();
          $state.go("billing.invoice.summary");
        }).catch(alerts.error).finally(() => {
          $scope.sending = false;
          $scope.saving = false;
        });
      }
    });
  };
  $scope.toggleShowSub = function () {
    $scope.showSub = !$scope.showSub;
    $scope.invoice.items.forEach(item => {
      item.showSub = item.combined && $scope.showSub;
    });
  };
  activate();

  //////////////////////////////////

  function activate() {
    $scope.format.includeHours = $stateParams.items.hours && $stateParams.items.hours.include;
    $scope.format.includeNone = $stateParams.items.none && $stateParams.items.none.include;
    $scope.format.includeExpenses = $stateParams.items.expenses && $stateParams.items.expenses.include;
    $scope.format.includeComputed = $stateParams.items.computed.some(i => i.include);
    if ($stateParams.items.fixed) {
      $scope.fixed = _.find($stateParams.items.fixed, f => f.include);
    }
    console.log("Scope format", $scope.format, $stateParams.items);
    userService.me().then(me => {
      $scope.me = me;
      $scope.customFlagLabel = me.company.settings.labels && me.company.settings.labels.customFlag;
      if (me.company.settings.invoice) {
        invoiceEditorService.setFormat(me.company.settings.invoice);
      }
      if (me.company.settings.trustEnabled) {
        invoiceEditorService.setConfig(me.company.settings.trust.trustConfig);
      }
    });
    if (!$stateParams.matterId && !$stateParams.only && !$stateParams.clientId) {
      throw 'client or matter id required';
    }
    const matterId = $stateParams.only || $stateParams.matterId;
    if (matterId) {
      initByMatter(matterId);
    } else if ($stateParams.clientId) {
      initByClient($stateParams.clientId);
    }
    $scope.$watch('filter', (state, previous) => {
      if (!invoiceFilterService.reload(_loadedState)) return;
      _loadedState = angular.copy(invoiceFilterService.state);
      const query = invoiceFilterService.filterQuery();
      const expenseQuery = invoiceFilterService.expenseFilterQuery();
      query.rangeLabel = $scope.filter.range?.label;
      $scope.loading = true;
      invoiceEditorService.load(query, expenseQuery, $scope.me).then(() => {
        $scope.loading = false;
      }).catch(err => {
        alerts.error(err);
      });
    }, true);
    $scope.$watch('format', (format, oldFormat) => {
      if (format == oldFormat) return;
      invoiceEditorService.reload();
    }, true);
  }
  function goInvoice(id) {
    if ($scope.matter) {
      return $state.go('billing.invoice.view', {
        id,
        matterId: $scope.matter.id
      });
    }
    return $state.go('billing.invoice.view', {
      id,
      clientId: $scope.client.id
    });
  }
  function initByMatter(id) {
    invoiceEditorService.setMatter(id, $stateParams.items.fixed, $stateParams.items.charges, $stateParams.items.extra, $stateParams.items.computed);
    matterManager.get(id).then(matter => {
      $scope.matter = matter;
      // invoiceFilterService.setMatter(matter);

      clientManager.get(matter.client.id).then(client => {
        if (client.settings && client.settings.invoice) {
          invoiceEditorService.setFormat(client.settings.invoice);
        }
        if (client.billing && client.billing.trustConfig) {
          invoiceEditorService.setConfig(client.billing.trustConfig);
        }
      }).catch(err => {
        alerts.error(err);
      });
      $scope.preventSubmit = true;
      matter.getOrConnectAccounting().then(accounting => {
        $scope.preventSubmit = false;
        return loadBalances(accounting, matter.client.billing.billClient ? matter.client.billing : matter.billing, $scope.me.terms.matter, () => {
          // Trust account doesn't exist anymore - happens when it is archived
          matter.billing.trust = {};
          return matter.update({
            billing: matter.billing
          });
        });
      }).catch(err => {
        // Quickbooks is enabled but not connected
        // console.log('!!');
        alerts.error(err);
      });
    });
  }
  function initByClient(id) {
    invoiceEditorService.setClient(id, $stateParams.items.fixed, $stateParams.items.charges, $stateParams.items.extra, $stateParams.items.computed);
    clientManager.get(id).then(client => {
      $scope.client = client;
      // invoiceFilterService.setClient(client);

      if (client.settings && client.settings.invoice) {
        invoiceEditorService.state.filter = client.settings.invoice;
      }
      if (client.accounting && !client.billing.billClient) {
        alerts.error(`The invoice contains multiple ${$scope.me.terms.matter}s but the client is set up for ${$scope.me.terms.matter} level accounting. Please invoice the matters individually.`);
        return $state.go('billing.invoice.summary');
        // alerts.warning("The invoice contains multiple " + $scope.me.terms.matter + "s. It will be billed at the client level in QuickBooks which might cause accounting issues. If you are not sure about this, invoice the matters individually.");
      }
      $scope.preventSubmit = true;
      client.getOrConnectAccounting().then(accounting => {
        $scope.preventSubmit = false;
        return loadBalances(accounting, client.billing, "client", () => {
          // Trust account doesn't exist anymore - happens when it is archived
          client.billing.trust = {};
          return client.update({
            billing: client.billing
          });
        });
      }).catch(err => {
        // Quickbooks is enabled but not connected
        alerts.error(err);
        //TODO!!
      });
    }).catch(err => {
      alerts.error(err);
    });
  }
  function loadBalances(accounting, billing, item, trustFailed) {
    if (accounting.connect) {
      return $state.go('.connect', {
        message: `To create an invoice the ${item} must be associated with a QuickBooks customer`,
        onCancel() {
          $scope.preventSubmit = true;
        }
      });
    }

    // Load trust balance
    if (accounting.trust) {
      $scope.invoice.trust = {
        loading: true
      };
      accountingService.getAccount(accounting.trust.account.id).then(account => {
        $scope.invoice.setTrust(account, billing.evergreen);
      }).catch(err => {
        $scope.invoice.trust = null;
        if (err.status == 404 && trustFailed) {
          return trustFailed();
        }
        alerts.error(err);
      });
    }

    // Load account balances
    if (accounting.matter || accounting.client) {
      $scope.accounts = {
        loading: true
      };
    }
    if (accounting.matter) {
      leanLawApi.getAccountingClient({
        id: accounting.matter.id
      }).then(account => {
        $scope.accounts.matter = account;
        $scope.accounts.loading = false;
      }).catch(err => {
        $state.go('billing.invoice.matter.create.connect', {
          message: `The ${$scope.me.terms.matter} wasn't found in QuickBooks. Please reconnect it to an existing QuickBooks client.`
        });
      });
    }
    if (accounting.client) {
      leanLawApi.getAccountingClient({
        id: accounting.client.id
      }).then(account => {
        $scope.accounts.client = account;
        $scope.accounts.loading = false;
      }).catch(err => {
        $state.go('billing.invoice.matter.create.connect', {
          message: "The client wasn't found in QuickBooks. Please reconnect it to an existing QuickBooks client."
        });
      });
    }
  }
  function print() {
    tracking.event('Invoice', 'Printed', {
      invoiceState: 'create'
    });
    window.print();
  }
}]);